const evaluationDefaultValues = {
    SATISFIED: 'Ja, dit past bij mij',
    DISSATISFIED: 'Nee, dit past niet (meer) bij mij',
    UNSURE: 'Dat weet ik (nog) niet',
};

export default evaluationDefaultValues;